import React from 'react'
import { observer, inject } from 'mobx-react'
import PropTypes from 'prop-types'
import AppModel, { NULL as AppModelNULL } from '@client/components/App/model'
import EditorModel, {
  NULL as EditorModelNULL,
} from '@client/components/Editor/model'

export const Ads = ({ editor = EditorModelNULL, app = AppModelNULL }) => {
  return (
    <If condition={editor.shouldShowAds}>
      <div className="promotion-block">
        <table
          cellSpacing="0"
          cellPadding="0"
          border="0"
          align="center"
          width="100%"
          style={{
            borderSpacing: '0',
            padding: '0 20px',
            color: '#666666',
            fontFamily: 'sans-serif',
          }}
        >
          <tbody>
            <tr>
              <td
                style={{ padding: '0', height: '20px' }}
                valign="top"
                height="20"
                align="center"
              ></td>
            </tr>
            <tr>
              <td style={{ padding: '0' }} valign="top" align="center">
                <div
                  style={{
                    color: '#555555',
                    fontSize: '12px',
                    textAlign: 'center',
                    fontFamily: 'Arial',
                    marginBottom: '5px',
                  }}
                >
                  {app.formatMessage('requiredLinksFooter.sentWith')}
                </div>
              </td>
            </tr>
            <tr>
              <td style={{ padding: '0' }} valign="top" align="center">
                <a
                  notrack="notrack"
                  href="https://www.getanewsletter.com/?a_aid=a26434&utm_source=freeaccount&utm_medium=email"
                  style={{ display: 'block', textDecoration: 'none' }}
                >
                  <img
                    style={{
                      width: '200px',
                      height: '45px',
                      display: 'block',
                    }}
                    width="200"
                    heigth="45"
                    src="https://cdn.getanewsletter.com/blockeditor/gan-logo.png"
                  />
                </a>
              </td>
            </tr>
            <tr>
              <td
                style={{ padding: '0', height: '20px' }}
                valign="top"
                height="20"
                align="center"
              ></td>
            </tr>
          </tbody>
        </table>
      </div>
    </If>
  )
}

Ads.propTypes = {
  editor: PropTypes.instanceOf(EditorModel),
  app: PropTypes.instanceOf(AppModel),
}

export default inject('editor', 'app')(observer(Ads))
